module.exports = __webpack_public_path__ + "public/img/shopify_logo_black.7f902ceb.png";